import React, { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

const BASE = "https://ltwph7gpvb.execute-api.us-east-1.amazonaws.com";

async function authHeaders() {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  return { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
}

const usd = (n) => "$" + Number(n).toLocaleString();

export default function Freight() {
  const [ports, setPorts] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [form, setForm] = useState({
    origin: "Mundra", destination: "Fujairah", cargo: "LPG",
    quantity: 40000, speed: 13, bunkerPrice: 640, dailyHire: 22000
  });
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BASE}/ports`, { headers: await authHeaders() });
        const data = await res.json();
        setPorts(data.ports);
        setCargos(data.cargos);
      } catch {
        setError("Could not load ports");
      }
    })();
  }, []);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  async function calculate() {
    setError("");
    setResult(null);
    setBusy(true);
    try {
      const res = await fetch(`${BASE}/freight`, {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || `Error ${res.status}`);
      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  const select = (label, key, options) => (
    <div>
      <label>{label}</label>
      <select value={form[key]} onChange={set(key)}>
        {options.map((o) => <option key={o}>{o}</option>)}
      </select>
    </div>
  );
  const input = (label, key) => (
    <div>
      <label>{label}</label>
      <input type="number" value={form[key]} onChange={set(key)} />
    </div>
  );

  return (
    <div className="card">
      <h2>Voyage details</h2>
      <div className="form">
        {select("Load port", "origin", ports)}
        {select("Discharge port", "destination", ports)}
        {select("Cargo", "cargo", cargos)}
        {input("Quantity (MT)", "quantity")}
        {input("Speed (knots)", "speed")}
        {input("Bunker price ($/MT)", "bunkerPrice")}
        {input("Daily hire ($)", "dailyHire")}
      </div>
      <button className="btn" onClick={calculate} disabled={busy}>
        {busy ? "Calculating..." : "Calculate"}
      </button>
      {error && <div className="err">{error}</div>}

      {result && (
        <>
          <div className="metrics">
            <div className="metric hero"><span>Indicative freight</span><b>${Number(result.freightPerMt).toFixed(2)} / MT</b></div>
            <div className="metric hero"><span>Total voyage</span><b>{result.totalDays} days</b></div>
            <div className="metric"><span>Distance</span><b>{result.distanceNm.toLocaleString()} nm</b></div>
            <div className="metric"><span>Sea passage</span><b>{result.seaDays} days</b></div>
            <div className="metric"><span>Loading / discharge</span><b>{result.loadDays} / {result.dischargeDays} days</b></div>
            <div className="metric"><span>Waiting</span><b>{result.waitDays} days</b></div>
            <div className="metric"><span>Bunkers</span><b>{usd(result.bunkers)}</b></div>
            <div className="metric"><span>Hire</span><b>{usd(result.hire)}</b></div>
            <div className="metric"><span>Port costs</span><b>{usd(result.portCosts)}</b></div>
            <div className="metric"><span>Suggested vessel</span><b>{result.suggestedVessel}</b></div>
          </div>
          <p className="note">{result.note}</p>
        </>
      )}
    </div>
  );
}